import React from 'react'
import { Route, IndexRoute, IndexRedirect } from 'react-router'

import Dashboard from './presenters/dashboard'

import Strategies from './presenters/strategies'
import StrategiesHistorical from './presenters/strategies/historical'
import StrategiesAggregate from './presenters/strategies/aggregate'

import Factors from './presenters/factors'
import FactorsHistorical from './presenters/factors/historical'
import FactorsAggregate from './presenters/factors/aggregate'

export default (
  <Route component={Dashboard} path="/">
    <IndexRedirect to="strategies" />

    <Route path="strategies" component={Strategies}>
      <IndexRoute component={StrategiesAggregate} />
      <Route path="compare" component={StrategiesHistorical} />
    </Route>

    <Route path="factors" section="factors" component={Factors}>
      <IndexRoute component={FactorsAggregate} />
      <Route path="compare" component={FactorsHistorical} />
    </Route>
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js